export const days = [
  {
    value: "sunday",
    title: "S",
  },
  {
    value: "monday",
    title: "M",
  },
  {
    value: "tuesday",
    title: "T",
  },
  {
    value: "wednesday",
    title: "W",
  },
  {
    value: "thursday",
    title: "T",
  },
  {
    value: "friday",
    title: "F",
  },
  {
    value: "saturday",
    title: "S",
  },
];

export const dayNightValues = [
  { value: "Day Session", option: "Day Session" },
  { value: "Night Session", option: "Night Session" },
];

// export const dayNightValues =(isAllowForNightService)=>{
//   console.log(isAllowForNightService,"isAllowForNightService")
//   if(isAllowForNightService==="no"){
//     return  [
//       { value: "Day Session", option: "Day Session" },

//     ];
//   }
//   else{
// return [
//   { value: "Day Session", option: "Day Session" },
//   { value: "Night Session", option: "Night Session" },
// ];
//   }

// }

export const noOfSessions = [
  4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
  25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43,
  44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62,
  63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81,
  82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99,
];

export const timeSelectionArrayForDay = (hour) => {
  if (hour === 3) {
    return [
      { hours: 8, minutes: 0, seconds: 0 },
      { hours: 8, minutes: 30, seconds: 0 },
      { hours: 9, minutes: 0, seconds: 0 },
      { hours: 13, minutes: 0, seconds: 0 },
      { hours: 13, minutes: 30, seconds: 0 },
      { hours: 14, minutes: 0, seconds: 0 },
    ];
  }

  if (hour === 4) {
    return [
      { hours: 8, minutes: 0, seconds: 0 },
      { hours: 14, minutes: 0, seconds: 0 },
    ];
  }

  return [];
};

export const timeSelectionArrayForNight = (hour) => {
  let timeArray
  if (hour === 3) {
    timeArray = [
      { hours: 18, minutes: 30, seconds: 0 },
      { hours: 19, minutes: 0, seconds: 0 },
      { hours: 19, minutes: 30, seconds: 0 },
    ]
  }
  else {
    timeArray = [
      { hours: 18, minutes: 0, seconds: 0 },
      { hours: 18, minutes: 30, seconds: 0 },
    ]
  }
  return timeArray
}

export const loadingContentForStaffAvailability = [
  " Checking for availability",
];
export const loadingContentForCreateJob = [
  "  Confirming availability",
  "  Saving into our calendar",
  "  Preparing our cleaning staffs",
  "  Connecting to payment gateway",
];
